function parallax() {
    "use strict";
	var scrollPosition = jQuery(window).scrollTop();
	var scrollOffset = scrollPosition * 0.3;
	var scrollOffset2 = scrollPosition * 0.2;
	var scrollOffset3 = scrollPosition * 0.1;

	//$('.image-container').css('top', -(scrollOffset) + 'px');
	jQuery('.image-container').css('transform', 'translatey(' + scrollOffset + 'px)');
	jQuery('.overlay-container').css('transform', 'translatey(' + scrollOffset2 + 'px)');
	jQuery('.text-container').css('transform', 'translatey(' + scrollOffset3 + 'px)');
}



jQuery(document).scroll(function(){
	"use strict";

    parallax();
});
